<GlobalNav backPath="{'/home'}" />
<div class="section">
  <div class="container">
    <div class="columns is-multiline">
      <div class="column is-8-desktop is-offset-2-desktop">
        <Heading />

        <div class="tabs is-centered is-medium mt-4 mb-6">
          <ul>
            <li class="{activeTab == 'Club' ? 'is-active' : 'Club'}">
              <a on:click="{() => setActiveTab('Club')}">Club</a>
            </li>
            {#if clubData.manager?.name}
              <li class="{activeTab == 'Manager' ? 'is-active' : 'Manager'}">
                <a on:click="{() => setActiveTab('Manager')}">Manager</a>
              </li>
            {/if}
            {#if clubData.team}
              <li class="{activeTab == 'PROs' ? 'is-active' : 'PROs'}">
                <a on:click="{() => setActiveTab('PROs')}">PROs</a>
              </li>
            {/if}
          </ul>
        </div>

        {#if activeTab == 'Club'}
          <div class="has-text-centered mb-6">
            <h2 class="is-size-4">Über uns</h2>
          </div>
          <!-- GOLFCLUB INFOS -->
          {#if clubData.golfclub?.video}
            <Videoplayer videoUrl="{clubData.golfclub?.video}" />
          {/if}
          {#if !clubData.golfclub?.video && clubData.golfclub?.image}
            <img
              class="is-max-width-90 mb-6"
              src="{clubData.golfclub?.image}"
            />
          {/if}
          <!-- {#if !clubData.golfclub?.video && clubData.golfclub?.image && clubData.golfclub?.about}
          <div class="columns">
            <div class="column is-half-desktop">
              <img class="is-max-width-90" src="{clubData.golfclub?.image}">
            </div>
            <div class="column is-half-desktop content">
            {@html clubData.golfclub?.about}
            </div>
          </div>
          {/if} -->
          {#if clubData.golfclub?.about}
            <div class="content">
              {@html clubData.golfclub?.about}
            </div>
          {/if}
        {/if}

        {#if activeTab == 'Manager'}
          <div class="container">
            <div class="has-text-centered mb-6">
              <h2 class="is-size-4">
                <span class="has-text-grey">Unser Club Manager:</span>
                {clubData.manager?.name}
              </h2>
            </div>

            <div class="columns">
              <div class="column is-half-desktop">
                {#if clubData.manager?.video}
                  <div class="is-max-width-90">
                    <Videoplayer videoUrl="{clubData.manager?.video}" />
                  </div>
                {/if}
                {#if clubData.manager?.image}
                  <img
                    class="is-max-width-90"
                    src="{clubData.manager?.image}"
                  />
                {/if}
              </div>
              <div class="column is-half-desktop content">
                {@html clubData.manager?.about}
              </div>
            </div>
          </div>
        {/if}

        {#if activeTab == 'PROs'}
          {#if clubData.team}
            <div class="has-text-centered mb-6">
              <h2 class="is-size-4">Unsere PROs</h2>
            </div>
            <div class="container pt-3">
              {#each clubData.team as pro, index}
                <a
                  class="accordion-handle is-size-5{activeAccordion == index ? ' is-active' : ''}"
                  on:click="{() => toggleAccordion(index)}"
                >{pro.name}

                  {#if activeAccordion == index}
                    <Icon
                      icon="chevron-down"
                      type="info"
                      size="medium"
                      iconSize="fa-lg"
                    />
                  {:else}
                    <Icon
                      icon="chevron-up"
                      type="info"
                      size="medium"
                      iconSize="fa-lg"
                    />
                  {/if}
                </a>
                {#if activeAccordion == index}
                  <div class="accordion-content p-3">
                    <div class="columns is-multiline">
                      {#if pro.video || pro.image}
                        <div class="column is-half-desktop">
                          {#if pro.video}
                            <div class="is-max-width-90">
                              <Videoplayer videoUrl="{pro.video}" />
                            </div>
                          {/if}
                          {#if pro.image}
                            <img class="is-max-width-90" src="{pro.image}" />
                          {/if}
                        </div>
                      {/if}
                      <div
                        class="column {pro.video || pro.image ? 'is-half-desktop' : ''} content"
                      >
                        {@html pro.about}
                      </div>
                      {#if filterEmptyVideos(pro.provideos)?.length > 0}
                        <div class="column mt-6">
                          <div class="columns is-multiline">
                            {#each filterEmptyVideos(pro.provideos) as video}
                              <div class="column is-6-desktop">
                                <div class="is-size-5 mt-5 mb-2">
                                  {video.headline}
                                </div>
                                <div class="is-max-width-90">
                                  <Videoplayer videoUrl="{video.video}" />
                                </div>
                                <div>{video.description}</div>
                              </div>
                            {/each}
                          </div>
                        </div>
                      {/if}
                    </div>
                  </div>
                {/if}
              {/each}
            </div>
          {/if}
        {/if}
      </div>
    </div>
  </div>
</div>

<script>
import GlobalNav from "./GlobalNav.svelte";
import Heading from "./Heading.svelte";
import Icon from "./Icon.svelte";
import { club } from "./stores";
import Videoplayer from "./Videoplayer.svelte";

let activeTab = "Club",
  activeAccordion,
  clubData;
club.subscribe((c) => (clubData = c));

const setActiveTab = (name) => {
  activeTab = name;
};

const toggleAccordion = (index) => {
  if (activeAccordion == index) {
    activeAccordion = null;
  } else {
    activeAccordion = index;
  }
};

const filterEmptyVideos = (list) => {
  return (list && list.filter((data) => !!data.video)) || [];
};
</script>

<style type="text/scss">
@import "./scss/colors";
.is-max-width-90 {
  max-width: 90%;
}
.is-max-width-100 {
  max-width: 100%;
}
.info-link {
  display: block;
  text-decoration: none;
}

.accordion-handle {
  display: block;
  position: relative;
  border: 1px solid $color-super-light-grey;
  border-bottom: 0;
  padding: 15px 20px;
  color: #000;
  &:hover,
  &.is-active {
    background-color: hsl(0, 0%, 98%);
  }
  &:last-child,
  &.is-active {
    border-bottom: 1px solid $color-super-light-grey;
  }
}
.accordion-content {
  border-right: 1px solid $color-super-light-grey;
  border-left: 1px solid $color-super-light-grey;
  border-bottom: 1px solid $color-super-light-grey;
}
:global(.accordion-handle .icon) {
  position: absolute;
  right: 15px;
}
</style>
